import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "ShitBrick", -1)
const _hoisted_2 = { class: "mt-3 text-end view-width d-flex align-items-center" }
const _hoisted_3 = {
  id: "table",
  class: "mt-3"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "mt-4 d-flex justify-content-around view-width" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["title"]
const _hoisted_8 = {
  key: 0,
  class: "alert alert-danger mt-4 view-width fw-bold",
  role: "alert"
}
const _hoisted_9 = {
  key: 1,
  class: "alert alert-primary mt-4 view-width fw-bold"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Game Over! ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("h3", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.table.reset && _ctx.table.reset(...args))),
        class: "me-auto fs-6 btn btn-danger"
      }, "Reset"),
      _createTextVNode(" " + _toDisplayString(_ctx.table.points), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.range(_ctx.table.rowAmount), (i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "d-flex",
          key: 'table-row-' + i,
          style: _normalizeStyle({
					height: `calc(100% / ${_ctx.table.rowAmount})`,
				})
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.range(_ctx.table.colAmount), (j) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'table-spot-' + i + j,
              onClick: ($event: any) => (_ctx.putPiece(i, j)),
              class: _normalizeClass(['border border-dark', _ctx.table.isFinished ? 'cursor-disabled': 'cursor-pointer']),
              style: _normalizeStyle({
						width: `calc(100% / ${_ctx.table.colAmount})`,
						backgroundColor: _ctx.table.matrix[i][j]
					})
            }, null, 14, _hoisted_4))
          }), 128))
        ], 4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.table.pieces, (piece, ind) => {
        return (_openBlock(), _createElementBlock("div", {
          key: 'piece-' + ind,
          class: _normalizeClass(['p-2', piece.disabled ? 'cursor-disabled': 'cursor-pointer', _ctx.selectedPiece == ind ? 'border border-2 border-dark': '']),
          onClick: ($event: any) => (piece.disabled ? null: _ctx.selectedPiece = ind)
        }, [
          _createElementVNode("abbr", {
            title: piece.disabled ? 'Piece does not fit anywhere': 'Tips: ' + piece.tips,
            style: {"cursor":"inherit"}
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.range(piece.rowAmount), (i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "d-flex",
                key: 'piece-row-' + i,
                style: {
							height: `20px`,
						}
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.range(piece.colAmount), (j) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "border border-white",
                    key: 'piece-spot-' + i + j,
                    style: _normalizeStyle({
								width: `20px`,
								backgroundColor: piece.matrix[i][j] ? piece.color: null
							})
                  }, null, 4))
                }), 128))
              ]))
            }), 128))
          ], 8, _hoisted_7)
        ], 10, _hoisted_6))
      }), 128))
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    (_ctx.table.isFinished)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _hoisted_11,
          _createTextVNode(" Points: " + _toDisplayString(_ctx.table.points), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}